import * as React from "react";
import { Button, ButtonGroup, Table } from "react-bootstrap";
import { AdminApiController } from "../../../models/AdminApiController.generated";
import { Profile } from "../../../models/Profile";
import { ProfileModal } from "./ProfileModal";
import { nonEditableProfile } from "../shared/helpers";

interface Props {
  userProfile?: Profile;
  getUserProfile: () => void;
}

interface State {
  profiles: Profile[];
  selectedProfile?: Profile;
  errorMessage?: string;
  showModal: boolean;
  profileModalErrorMessage?: string;
}

export class ProfilesPage extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      profiles: [],
      showModal: false
    };
  }

  componentDidMount() {
    AdminApiController.getNonUniqueProfiles().then(resp => {
      if (resp.result) {
        this.setState({ profiles: resp.profiles });
      } else {
        this.setState({ errorMessage: resp.message });
      }
    });
  }

  handleSaveProfile = (profile: Profile) => {
    AdminApiController.addProfile(profile)
      .then(resp => {
        if (resp.result) {
          this.addItemToState(resp.profile);
          this.closeModal();
        } else {
          this.setState({
            profileModalErrorMessage: resp.message
          });
        }
      })
  }

  handleUpdateProfile = (profile: Profile) => {
    AdminApiController.updateProfile(profile)
      .then(resp => {
        if (resp.result) {
          this.updateState(resp.profile);
          this.closeModal();
          this.props.getUserProfile();
        } else {
          this.setState({
            profileModalErrorMessage: resp.message
          });
        }
      });
  }

  addItemToState = profile => {
    this.setState(prevState => ({
      profiles: [...prevState.profiles, profile]
    }));
  };

  updateState = profile => {
    const pIndex = this.state.profiles.findIndex(p => p.id === profile.id);
    const newArray = [
      ...this.state.profiles.slice(0, pIndex),
      profile,
      ...this.state.profiles.slice(pIndex + 1)
    ];
    this.setState({ profiles: newArray });
  };

  deleteItemFromState = id => {
    const profiles = this.state.profiles.filter(p => p.id !== id);
    this.setState({ profiles: profiles });
  };

  closeModal = () => {
    this.setState({
      selectedProfile: null,
      showModal: false,
      profileModalErrorMessage: null
    })
  }

  renderModal() {
    if (!this.state.showModal) { return null;}
    return (
      <ProfileModal
        profile={this.state.selectedProfile} // null here means to add a new profile
        errorMessage={this.state.profileModalErrorMessage}
        closeModal={this.closeModal}
        saveProfile={this.handleSaveProfile}
        updateProfile={this.handleUpdateProfile}
      />
    )
  }

  render() {
    return (
      <React.Fragment>
        {this.renderModal()}
      <div className="profile-list tab-inner">
        {this.state.errorMessage ? (
          <div className="alert alert-danger" role="alert">{this.state.errorMessage}</div>
        ): (
          <React.Fragment>
            <h2>Profiles</h2>
            <Button
              className={"btn btn-add btn-success"}
              onClick={() => this.setState({ showModal: true })}
            >
              Add
            </Button>
            <Table striped bordered hover size="sm">
              <thead>
                <tr>
                  <th>Profile name</th>
                  <th>Description</th>
                  <th>Edit Profiles</th>
                  <th>View Areas</th>
                  <th>Edit Areas</th>
                  <th>View Users</th>
                  <th>Edit Users</th>
                  <th>Import/Export</th>
                  <th>Edit Projects</th>
                  <th>Print Project Reports</th>
                  <th>Customize DataSheet</th>
                  <th>Edit Sites</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {this.state.profiles.map(profile => (
                  <tr key={profile.id}>
                    <td>{profile.name}</td>
                    <td>{profile.description}</td>
                    <td>
                      <BoolCheck value={profile.profileTab} />
                    </td>
                    <td>
                      <BoolCheck value={profile.viewAreas} />
                    </td>
                    <td>
                      <BoolCheck value={profile.areaTab} />
                    </td>
                    <td>
                      <BoolCheck value={profile.viewUsers} />
                    </td>
                    <td>
                      <BoolCheck value={profile.userTab} />
                    </td>
                    <td>
                      <BoolCheck value={profile.importExport} />
                    </td>
                    <td>
                      <BoolCheck value={profile.createEditProject} />
                    </td>
                    <td>
                      <BoolCheck value={profile.printReports} />
                    </td>
                    <td>
                      <BoolCheck value={profile.createCustomDatasheet} />
                    </td>
                    <td>
                      <BoolCheck value={profile.editSites} />
                    </td>
                    <td>
                      <div className="action-btns">
                        <ButtonGroup>
                          <Button
                            variant="success"
                            className={"btn btn-edit"}
                            onClick={() => this.setState({ showModal: true, selectedProfile: profile })}
                          >
                            Edit
                          </Button>
                          <Button
                            variant={nonEditableProfile(profile) ? "dark" : "outline-warning"}
                            className="btn btn-delete"
                            onClick={() => this.deleteProfile(profile.id)}
                            disabled={nonEditableProfile(profile)}
                          >
                              Delete
                          </Button>
                        </ButtonGroup>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </React.Fragment>
        )}
        </div>
        </React.Fragment>
    );
  }

  private deleteProfile(id: number) {
    let confirmDelete = window.confirm(
      "Are you sure you want to delete this profile?"
    );
    if (confirmDelete) {
      console.log("deleting profile: " + id);
      AdminApiController.deleteProfile(id).then((result) => {
        if (result.result) {
          this.deleteItemFromState(id);
        } else {
          alert(result.message);
        }
      });
    }
  }
}

function BoolCheck(props) {
  return (
    <i
      className={"bool-check " + (props.value ? "fa fa-check" : "fa fa-close")}
    />
  );
}
